import { Component, OnInit, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AttributeInterface } from 'src/app/model/attributes/attribute-interface';

import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { DialogService } from '../../../services/dialog-service/dialog-service.service';

import { AttributeService } from 'src/app/services/dataServices/attribute-service/attributeService';
import { UserService } from 'src/app/services/user-service/userservice';

@Component({
    selector: 'app-attributes-screen',
    templateUrl: './attributes-screen.component.html',
    styleUrls: ['./attributes-screen.component.css'],
    standalone: false
})
export class AttributesScreenComponent implements OnInit {
    @Input()
    public featureForm: UntypedFormGroup;

    constructor(
        public organisationService: OrganisationService,
        private attributeService: AttributeService,
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private dialogService: DialogService,
        private userService: UserService
    ) {
        //Reroutes to the Marketplace if the User is not a member of the Organisation
        if (
            !this.userService.currentMemberships.find(
                (orga) =>
                    orga.organisationId ===
                    this.organisationService.activeItem.organisationId
            )
        ) {
            this.router.navigateByUrl('/marktplatz');
        }
    }

    ngOnInit(): void {
        this.featureForm = this.formBuilder.group({
            featureName: '',
            description: ''
        });
    }

    onSubmit(form: UntypedFormGroup): boolean {
        if (!form.value.featureName) {
            this.dialogService.openDialog(
                'Merkmal anlegen',
                'Bitte geben Sie einen Namen an!'
            );
            return false;
        }

        const feature: AttributeInterface = {
            name: form.value.featureName,
            datatype: 'BOOLEAN',
            description: form.value.description,
            validations: [
                {
                    attributeName: form.value.featureName,
                    description: '',
                    value: true
                }
            ]
        };

        this.dialogService.openDialogAttribute(feature).subscribe((result) => {
            if (result) {
                this.attributeService
                    .save(feature)
                    .then((attribute) => {
                        this.router.navigate([
                            '/organisations/' +
                                this.organisationService.activeItem
                                    .organisationId +
                                '/features'
                        ]);
                        this.dialogService.openDialog(
                            'Merkmal erstellt',
                            'Das Merkmal: ' +
                                attribute.name +
                                ' wurde erfolgreich angelegt.'
                        );
                    })
                    .catch((error: HttpErrorResponse) => {});
            } else {
                return false;
            }
        });
    }

    cancel(): void {
        this.router.navigate([
            '/organisations/' +
                this.organisationService.activeItem.organisationId +
                '/features'
        ]);
    }
}
